<template>
  <div class="lesson-detail">
    <div class="title-box">
      <img :src="detailData.pic" alt="">
      <h3>{{detailData.name}}</h3>
      <p>{{detailData.subtitle}}</p>
    </div>
    <!-- <dl class="location-detail">
      <dt><span></span>上课老师：</dt>
      <dd>{{detailData.teacher}}</dd>
      <dt><span></span>上课地点（线下）：</dt>
      <dd>{{detailData.address}}</dd>
      <dt><span></span>报名时间：</dt>
      <dd>{{detailData.registrationStartTime|dateFormat}} 至 {{detailData.registrationEndTime|dateFormat}}</dd>
      <dt><span></span>上课时间：</dt>
      <dd>{{detailData.classStartTime|dateFormat}} 至 {{detailData.classEndTime|dateFormat}}</dd>
    </dl> -->
    <div class="content-box">
      <h4>课程简介</h4>
      <img :src="detailData.detailPic" alt="">
    </div>
    <button-bar mode="lesson-offline-detail" :buyState="!!goodsDetail.buyStatus" :isFree="isFree"
      @bottomBarHandler="bottomBarHandler">
      <template v-slot:lessonBuy>
        <div
          v-html="isPlusMember ? `立即购买（<span class='ico'>  ¥</span>${memberPrice}  <span style='font-size:14px;text-decoration: line-through;display:${isMarketPriceShow}'>${marketPrice}</span>）`: `立即购买（<span class='ico'>  ¥</span>${marketPrice}）`">
        </div>
      </template>
      <template v-slot:salesVolume>
        <div v-html="`${detailData.salesVolume ? detailData.salesVolume+detailData.virtualSales : detailData.virtualSales || 0}人已购`"></div>
      </template>
      <template v-slot:buy>
        <!-- wechatGuideStatus 0:关闭，1：开启 -->
        <div class="buy-btn" v-if="detailData.wechatGuideStatus" @click="isExchangeInfoShow=true" v-html="'您已成功购买，查看购买信息'"></div>
        <div v-else v-html="'你已报名成功'"></div>
      </template>
      <template v-slot:lessonShare>
        <div v-html="`分享赚 ¥${shareProfit ? shareProfit : 0}`"></div>
      </template>
    </button-bar>
    <!-- <cus-share v-show="shareShow" @cancel="shareShow=false"></cus-share> -->
    {{shareText}}
    <exchange-info v-if="isExchangeInfoShow" :exchangeInfoData="exchangeInfoData"
      @exchangeInfoClose="exchangeInfoClose" @saveQrPic="saveQrPic"></exchange-info>
    <experience-pkg-share v-model="shareShow" @close="shareShow = false" :shareData="shareData" :styleData="styleData">
    </experience-pkg-share>
  </div>
</template>
<script>
  import buttonBar from "@/components/goods/pkgButtonBar";
  import {
    resourceType
  } from "@/utils/const";
  import {
    mapGetters,
    mapMutations
  } from "vuex";
  import {
    isEmpty
  } from "lodash";
  import {
    Config
  } from "@/utils";
  import dayjs from "dayjs";
  import Browser from "@/utils/browser";
  import {
    wechatSharePkgPage
  } from "@/mixins/wechatShare.js";
  import {
    ExchangeInfo
  } from '@/components/course';
  import {
    ExperiencePkgShare
  } from '@/components/goods';

  const styleData = {
          shareTextBoxStyle: {
            backgroundColor: '#FFFFFF'
          },
          tipsStyle: {
            color: '#454545'
          }
        };

  export default {
    mixins: [wechatSharePkgPage],
    components: {
      buttonBar,
      ExchangeInfo,
      ExperiencePkgShare
    },
    data() {
      return {
        detailData: {},
        goodsDetail: {
          memberPrice: 0,
          price: 0
        },
        buyStatus: false,
        shareProfit: null,
        shareShow: false,
        resourceType,
        isExchangeInfoShow: false,
        posterData: [],
        styleData,
        courseBuyExchange: false,
      };
    },
    watch: {
      "$route.query": {
        immediate: true,
        handler: function (query) {
          this.courseBuyExchange = sessionStorage.getItem("courseExchangeShow");
          if (query.mode === "complete") {
            if (Browser.isIOS() && !this.isNative) {
              this.$createDialog({
                type: "alert",
                icon: "cubeic-alert",
                title: "提示",
                content: "请返回APP进行下一步操作",
                onConfirm: () => {
                  window.close();
                }
              }).show();
            } else {
              this.$createDialog({
                type: "confirm",
                icon: "cubeic-alert",
                title: "提示",
                content: "是否完成支付",
                confirmBtn: {
                  text: "完成支付",
                  active: true,
                  disabled: false,
                  href: "javascript:;"
                },
                cancelBtn: {
                  text: "重新支付",
                  active: false,
                  disabled: false,
                  href: "javascript:;"
                },
                onConfirm: async () => {
                   await sessionStorage.setItem("courseExchangeShow", true);
                     this.$nextTick( () => {  
                       this.$router.go(-3); 
                  })    
                },
                onCancel: () => {
                  this.$router.go(-2);
                }
              }).show();
            }
          }else if(query.mode === "webcomplete"){
            this.courseBuyExchange = true;
          }
        }
      },
      goodsId: {
        immediate: true,
        handler: function (id) {
          this.loadData();
        }
      },
      isPlusMember: {
        immediate: true,
        handler: function(val) {
          if(val){
            this.getPoster()
          }
          // if (val) {
          //   // this.getShareText()
          //   console.log(this.getShareText(), 11111111111111)
          //   this.$setShareConfig(this.getShareText());
          // }else{
          //   this.$toggleWechatShareItems(false)
          // }
        }
      },
      payCompeleteStatus: {
        immediate: true,
        handler: function (val) {
           if(val){
             this.isExchangeInfoShow = true;
           }
        }
      },
    },
    filters: {
      dateFormat(val) {
        return dayjs(val).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    methods: {
      ...mapMutations({
        setLoading: "setLoadingShow",
        setToast: "setToastShow",
      }),
      getShareTitle() {
        return `${this.userInfo.mainName ? this.userInfo.mainName:''}邀您一起报名学习${this.detailData.name||""}`
      },
      getShareLink() {
        return `${
              process.env.VUE_APP_SHARE_URL
            }/share.html?path=/course/detail/${this.goodsId}${
              this.selfInviteCode ? "&contextId=" + this.selfInviteCode : ""
            }`
      },
      getShareDesc() {
        return `${this.detailData.subtitle||""}`
      },
      login() {
        if (this.isNative) {
          this.$store.dispatch("externalInterface/navigateTo", {
            name: "login",
            params: {
              redirect: `${process.env.VUE_APP_SHARE_URL}/share.html?path=/course/detail/${this.goodsId}`
            }
          });
        } else {
          this.$router.push("/account/login-bySMS");
        }
      },
      //线下课详情
      loadData() {
        this.setLoading({
          show: true
        });
        this.$api
          .payment_v1_goods_offline_course_id_get({
            path: {
              id: this.goodsId
            }
          })
          .then(e => {
            if (e) {
              this.detailData = e;
              this.getBuyStatus();
              this.getShareProfit();
              this.setLoading({
                show: false
              });
            }
          });
      },
      //获取海报
      getPoster(){
        this.$api.api_v3_invite_card_search_page_post({
          data:{
            courseId: this.goodsId,
            pageNo: 1,
            pageSize: 999,
            status: 1,
            type: 3
          }
        }).then(e=>{
          if(!e) return
          this.posterData = e.content
        })
      },
      //判断是否购买
      getBuyStatus() {
        this.$api
          .payment_v1_goods_getGoodsNum_get({
            params: {
              id: this.detailData.correlationId,
              type: this.resourceType.lesson
            }
          })
          .then(e => {
            if (!e) return;
            this.goodsDetail = e;
          });
      },
      //获取会员分销
      getShareProfit() {
        this.$api
          .payment_v1_goods_profit_ids_list_post({
            data: {
              ids: [this.detailData.id]
            }
          })
          .then(e => {
            if (e && e.length) {
              this.shareProfit = e[0].profit;
            }
          });
      },
      bottomBarHandler(flag) {
        if (flag == "lessonBuy") {
          if (this.isVisitor || isEmpty(this.userInfo)) {
            this.login();
          } else {
            // let toastText = "课程报名时间尚未开始";
            // toastText =
            //   this.detailData.registrationEndTime - this.detailData.sysTime <= 0 ?
            //   "课程报名时间已截止" :
            //   "课程报名时间尚未开始";
            // if (
            //   this.detailData.registrationStartTime - this.detailData.sysTime >
            //   0 ||
            //   this.detailData.registrationEndTime - this.detailData.sysTime <= 0
            // ) {
            //   this.$createToast({
            //     txt: toastText,
            //     type: "txt"
            //   }).show();
            //   return;
            // }
            if(this.detailData.surplusNum<1){
              this.$createToast({
                txt: "课程已售罄，暂不可购买",
                type: "txt"
              }).show();
               return;
            }
            this.$router.push({
              path: `/checkout/course/${
              this.detailData.correlationId
            }?redirect_url=${encodeURIComponent(location.href)}`,
              query: {
                goodsId: this.detailData.id
              }
            });
          }
        } else if (flag == "lessonShare") {
          this.shareToInvite();
        }
      },
      shareToInvite() {
        if (this.isNative) {
          // this.$store.dispatch("externalInterface/requestShare", {
          //   desc: "",
          //   title: `${this.adultInfo.name}邀您一起报名学习${this.detailData.name}`,
          //   imgUrl: process.env.VUE_APP_SHARE_URL + Config.SHARE_IMAGE_URL,
          //   link: `${process.env.VUE_APP_SHARE_URL}/share.html?path=/course/detail/${this.goodsId}` +
          //     (this.selfInviteCode ? `&contextId=${this.selfInviteCode}` : "")
          // });
          this.$store.dispatch('externalInterface/toInvite', {
          name: 'poster',
          type: 'courseDetail',
          posterInfo: this.posterDataMain
        })
        } else {
          this.shareShow = true;
        }
      },
      exchangeInfoClose() {
        this.isExchangeInfoShow = false;
        sessionStorage.removeItem("courseExchangeShow");
      },
      saveQrPic(){
         if (this.isNative) {
           setTimeout(() => {
             this.$store.dispatch('externalInterface/toInvite', {
              name: 'saveQrPic',
              type: 'courseQrPic',
              url: this.detailData.qrPic
        })
         }, 1000);    
         }
      }
    },
    computed: {
      goodsId() {
        return this.$route.params.id;
      },
      isFree() {
        return this.detailData.privilege == 0 && this.detailData.canBuy == 0;
      },
      isMarketPriceShow() {
        return this.goodsDetail.memberPrice >= this.goodsDetail.price ?
          "none" :
          "inline-block";
      },
      memberPrice() {
        return this.goodsDetail.memberPrice && this.goodsDetail.memberPrice.toFixed(2)
      },
      marketPrice() {
        return this.goodsDetail.price && this.goodsDetail.price.toFixed(2)
      },
      ...mapGetters({
        isVisitor: "auth/isVisitor",
        userInfo: "auth/userInfo",
        isPlusMember: "auth/isPlusMember",
        uid: "auth/uid",
        selfInviteCode: "auth/selfInviteCode",
        adultInfo: "auth/adultInfo",
        isNative: "externalInterface/isNative"
      }),
      shareText() {
        if (this.isPlusMember) {
          this.$setShareConfig(this.getShareText());
        } else {
          this.$toggleWechatShareItems(false)
        }
        return "";
      },
      posterDataMain(){
          let posterSrcData = [];
          for(let item of this.posterData){
            posterSrcData.push({picUrl:item.displayPic,title:isEmpty(item.recommendWord)?'正在智伴优学畅学好课':item.recommendWord})
          }
        return isEmpty(posterSrcData) ? [{picUrl:'/images/course/default-poster.png',title:'正在智伴优学畅学好课'}]:posterSrcData
      },
      shareData() {
        return {
          qrcodeSrc: `${process.env.VUE_APP_SHARE_URL}/share.html?path=/course/detail/${this.goodsId}` +
              (this.selfInviteCode ? `&contextId=${this.selfInviteCode}` : ""),
          posterInfo: this.posterDataMain
        }
      },
      exchangeInfoData() {
        return {
          code: this.detailData.code || '',
          qrTitle: this.detailData.qrTitle || '',
          qrPic: this.detailData.qrPic || '',
          wechatGuideDescription: this.detailData.wechatGuideDescription || '',
        };
      },
      payCompeleteStatus(){
        //goodsDetail.buyStatus:0 购买, 购买成功返回后弹出引导框，wechatGuideStatus：1开启引导，wechatGuideType：0购买成功弹框引导
        return !!this.goodsDetail.buyStatus &&  this.courseBuyExchange && this.detailData.wechatGuideStatus==1 && this.detailData.wechatGuideType==0
      }
    },
  };
</script>
<style scoped>
  .lesson-detail {
    background-color: #f9f9f9;
    padding-bottom: 45px;
    height: 100vh;
    box-sizing: border-box;
  }

  .title-box {
    background-color: #fff;
    margin-bottom: 8px;
  }

  .content-box {
    padding-bottom: 80px;
  }

  .title-box img,
  .content-box img {
    width: 375px;
    display: block;
  }

  .title-box h3 {
    font-size: 16px;
    color: rgba(36, 67, 82, 1);
    line-height: 21px;
    text-align: center;
    padding: 24px 18px 16px;
  }

  .title-box p {
    display: block;
    font-size: 14px;
    color: rgba(106, 146, 164, 1);
    line-height: 22px;
    padding: 0 18px 24px;
  }

  .content-box {
    background-color: #fff;
  }

  .content-box h4 {
    font-size: 20px;
    color: rgba(36, 67, 82, 1);
    line-height: 26px;
    text-align: center;
    padding: 17px 0 21px;
  }

  .content-box h4::before,
  .content-box h4::after {
    display: inline-block;
    content: "";
    width: 16px;
    height: 8px;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 2px;
  }

  .content-box h4::before {
    background-image: url("/images/course/icon00.png");
    margin-right: 8px;
  }

  .content-box h4::after {
    background-image: url("/images/course/icon01.png");
    margin-left: 8px;
  }

  .location-detail {
    background: #fff;
    margin-bottom: 8px;
    padding: 24px 25px 8px;
  }

  .location-detail dt {
    font-size: 14px;
    color: #444e53;
    line-height: 20px;
    font-weight: bold;
    padding-bottom: 6px;
  }

  .location-detail dt span {
    display: inline-block;
    height: 10px;
    width: 10px;
    background: #84b3f4;
    border-radius: 20px;
    vertical-align: baseline;
    margin-right: 10px;
  }

  .location-detail dd {
    font-size: 14px;
    color: #5c6a71;
    line-height: 24px;
    padding-left: 20px;
    padding-bottom: 16px;
  }

  .buy-btn {
    font-size: 13px;
  }

  .lesson-detail >>> .salesVolume, .lesson-detail >>> .lessonShare{
    flex: 0.9
  }

  .lesson-detail >>> .lessonBuy{
    flex: 1
  }
</style>